import { render, staticRenderFns } from "./facilityDetailTab.vue?vue&type=template&id=47ff8ec2&scoped=true&"
import script from "./facilityDetailTab.vue?vue&type=script&lang=js&"
export * from "./facilityDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./facilityDetailTab.vue?vue&type=style&index=0&id=47ff8ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff8ec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VTab,VTabItem,VTabs,VTabsItems})
